<app-config-top-nav></app-config-top-nav>

<div class="pay-codes-container">
  <div *ngIf="isLoading" class="spinner-container">
    <div class="spinner"></div>
  </div>

  <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>

  <div class="header" *ngIf="!isLoading">
    <h2>Pay Codes</h2>

    <div class="header-actions">
      <button class="btn btn-primary" (click)="openCreateModal()">+ New Pay Code</button>
    </div>
  </div>

  <div class="pagination sticky" *ngIf="!isLoading">
    <div class="page-controls">
      <button (click)="prevPage()" [disabled]="currentPage === 1">Prev</button>
      <span>Page {{ currentPage }} of {{ totalPages }}</span>
      <button (click)="nextPage()" [disabled]="currentPage === totalPages">Next</button>
    </div>

    <div class="page-size">
      <label for="pageSize">Page Size:</label>
      <select id="pageSize" [(ngModel)]="pageSize" (change)="changePageSize()">
        <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</option>
      </select>
    </div>
  </div>

  <div class="filters-container" *ngIf="!isLoading">
    <div class="filters-row">
      <label class="filter-field search-field">
        <app-search-bar
          [value]="filters.searchTerm"
          [debounceMs]="1000"
          placeholder="Search pay code name"
          (searchChange)="onSearchTermChange($event)">
        </app-search-bar>
      </label>
    </div>
  </div>

  <div class="pay-codes-list">
    <div *ngFor="let payCode of payCodes$ | async" class="pay-code-row">
      <div class="pay-code-info">
        <div class="pay-code-name">{{ payCode.name }}</div>
        <div class="pay-code-description">{{ payCode.description || '' }}</div>

        <div class="pay-code-meta">
          <span>Type: {{ payCode.type }}</span>

          <span
            class="status-text"
            [class.active]="payCode.isActive"
            [class.inactive]="!payCode.isActive">
            {{ payCode.isActive ? 'Active' : 'Inactive' }}
          </span>

          <span *ngIf="payCode.isDayOff">Day Off</span>
          <span *ngIf="payCode.isPaid">Paid</span>
          <span *ngIf="payCode.isHoliday">Holiday</span>
          <span *ngIf="payCode.shift">Shift: {{ payCode.shift.name }}</span>
        </div>
      </div>

      <div class="pay-code-actions">
        <button class="btn edit" (click)="openEditModal(payCode)">Edit</button>

        <button
          *ngIf="!payCode.isActive"
          class="btn activate"
          (click)="requestActivate(payCode)">
          Activate
        </button>

        <button
          *ngIf="payCode.isActive"
          class="btn deactivate"
          (click)="requestDeactivate(payCode)">
          Deactivate
        </button>

        <button class="btn delete" (click)="requestDelete(payCode)">Delete</button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="modalOpen" class="modal-backdrop">
  <div class="modal pay-code-modal" (click)="$event.stopPropagation()">
    <h2>{{ isEditMode ? 'Edit Pay Code' : 'New Pay Code' }}</h2>

    <form #payCodeForm="ngForm" (ngSubmit)="requestSubmitPayCode(payCodeForm)">
      <label for="payCodeName">Name</label>
      <input
        id="payCodeName"
        type="text"
        [(ngModel)]="formModel.name"
        name="name"
        required />

      <label for="payCodeDescription">Description</label>
      <textarea
        id="payCodeDescription"
        [(ngModel)]="formModel.description"
        name="description">
      </textarea>

      <label for="payCodeType">Type</label>
      <select
        id="payCodeType"
        [(ngModel)]="formModel.type"
        name="type"
        required>
        <option *ngFor="let type of payCodeTypes" [ngValue]="type">{{ type }}</option>
      </select>

      <label class="checkbox-label">
        <input type="checkbox" [(ngModel)]="formModel.isDayOff" name="isDayOff" />
        Day Off
      </label>

      <label class="checkbox-label">
        <input type="checkbox" [(ngModel)]="formModel.isPaid" name="isPaid" />
        Paid
      </label>

      <label class="checkbox-label">
        <input type="checkbox" [(ngModel)]="formModel.isHoliday" name="isHoliday" />
        Holiday
      </label>

      <div class="modal-buttons">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancel</button>
        <button type="submit" class="btn btn-primary" [disabled]="isSaving">
          {{ isEditMode ? 'Update' : 'Create' }}
        </button>
      </div>
    </form>
  </div>
</div>

<div *ngIf="confirmState.open" class="modal-backdrop">
  <div class="modal confirm-modal" (click)="$event.stopPropagation()">
    <h2>{{ confirmState.title }}</h2>

    <p class="modal-text">
      {{ confirmState.message }}
    </p>

    <div class="modal-buttons confirm-buttons">
      <button
        type="button"
        class="btn btn-secondary"
        (click)="cancelConfirm()"
        [disabled]="isSaving">
        Cancel
      </button>

      <button
        type="button"
        class="btn"
        [class.btn-danger]="confirmState.action === 'delete' || confirmState.action === 'deactivate'"
        [class.btn-primary]="confirmState.action !== 'delete' && confirmState.action !== 'deactivate'"
        (click)="confirmAction()"
        [disabled]="isSaving">
        {{ confirmState.confirmText }}
      </button>
    </div>
  </div>
</div>

<div *ngIf="toastVisible" class="toast" [ngClass]="toastType">
  <img class="icon" alt="icon" />
  <span>{{ toastMessage }}</span>
</div>